(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["announcement-bar"] && !Shopify.designMode) return;
  try {
    // document.addEventListener("DOMContentLoaded", function () {
//   const timer = document.querySelector(".timer_lineSs");
//   if (!timer) return;

//   const dateAttr = timer.getAttribute("data-dates");

//   // Parse target date as AEDT (Australia/Sydney) time
//   const targetDate = new Date(
//     new Date(dateAttr + " GMT+11").toLocaleString("en-US", { timeZone: "Australia/Sydney" })
//   ).getTime();

//   const daysEl = timer.querySelector(".days");
//   const hoursEl = timer.querySelector(".hours");
//   const minutesEl = timer.querySelector(".minutes");
//   const secondsEl = timer.querySelector(".seconds");

//   // Get current time in Sydney
//   function getAustraliaNow() {
//     return new Date(
//       new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" })
//     ).getTime();
//   }

//   function updateTimer() {
//     const now = getAustraliaNow();
//     const distance = targetDate - now;

//     if (distance <= 0) {
//       daysEl.textContent = "00";
//       hoursEl.textContent = "00";
//       minutesEl.textContent = "00";
//       secondsEl.textContent = "00";
//       clearInterval(timerInterval);
//       return;
//     }

//     const days = Math.floor(distance / (1000 * 60 * 60 * 24));
//     const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//     const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//     const seconds = Math.floor((distance % (1000 * 60)) / 1000);

//     daysEl.textContent = String(days).padStart(2, "0");
//     hoursEl.textContent = String(hours).padStart(2, "0");
//     minutesEl.textContent = String(minutes).padStart(2, "0");
//     secondsEl.textContent = String(seconds).padStart(2, "0");
//   }

//   updateTimer();
//   const timerInterval = setInterval(updateTimer, 1000);
// });

document.addEventListener("DOMContentLoaded", function () {
  const timer = document.querySelector(".timer_lineSs");
  if (!timer) return;

  // Inject HTML automatically
  timer.innerHTML = `
    <div class="timer__box">
      <span class="days">00</span><sub>D</sub>
    </div>
    <div class="timer__box">
      <span class="hours">00</span><sub>H</sub>
    </div>
    <div class="timer__box">
      <span class="minutes">00</span><sub>M</sub>
    </div>
    <div class="timer__box">
      <span class="seconds">00</span><sub>S</sub>
    </div>
  `;

  let dateAttr = timer.getAttribute("data-dates");

  // ✅ Convert "YYYY-MM-DD HH:MM:SS" → "YYYY-MM-DDTHH:MM:SS"
  if (dateAttr.includes(" ")) {
    dateAttr = dateAttr.replace(" ", "T");
  }

  // Parse target date as Australia/Sydney time
  const targetDate = new Date(
    new Date(dateAttr).toLocaleString("en-US", {
      timeZone: "Australia/Sydney"
    })
  ).getTime();

  const daysEl = timer.querySelector(".days");
  const hoursEl = timer.querySelector(".hours");
  const minutesEl = timer.querySelector(".minutes");
  const secondsEl = timer.querySelector(".seconds");

  function getAustraliaNow() {
    return new Date(
      new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" })
    ).getTime();
  }

  function updateTimer() {
    const now = getAustraliaNow();
    const distance = targetDate - now;

    if (distance <= 0) {
      daysEl.textContent = "00";
      hoursEl.textContent = "00";
      minutesEl.textContent = "00";
      secondsEl.textContent = "00";
      clearInterval(timerInterval);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    daysEl.textContent = String(days).padStart(2, "0");
    hoursEl.textContent = String(hours).padStart(2, "0");
    minutesEl.textContent = String(minutes).padStart(2, "0");
    secondsEl.textContent = String(seconds).padStart(2, "0");
  }

  updateTimer();
  const timerInterval = setInterval(updateTimer, 1000);
});
  } catch(e) { console.error(e); }
})();

})();
